

































import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { Company } from "@/models/company.entity";
import { IInvoiceParty } from "@/models/invoice-party.entity";
import { Person } from "@/models/person.entity";
import { BackendResourceEnum } from "@/store/enum/authResourceEnum";
import { PartnerModule } from "@/store/modules/partner";
import { RefTypeMap } from "@/store/modules/refs.store";
import { Component, Prop } from "vue-property-decorator";
import BaseRef from "./BaseRef.vue";
import { IRefDetail } from "./RefsList.vue";
import Tooltip from "./tooltip.vue";

@Component({
  components: { Tooltip },
  filters: { simpleDoubleDigitDate }
})
export default class RefInvoiceParty extends BaseRef<IInvoiceParty> implements IRefDetail<IInvoiceParty> {
  readonly RefsTypeMap = RefTypeMap;

  @Prop()
  item!: IInvoiceParty;

  @Prop({ default: false })
  small!: boolean;

  @Prop({ default: false })
  confirmable!: boolean;

  @Prop()
  partnerId?: string;

  goToDetail() {
    const partnerId = this.partnerId ?? PartnerModule.partner.id;
    const ref = this.item?.ref;
    if (!ref?.refType) {
      return;
    }

    switch (ref.refType) {
      case BackendResourceEnum.PERSON:
        new Person({ id: ref.refId, partnerId: partnerId }).goTo(this.$router).detail();
        break;

      case BackendResourceEnum.COMPANY:
        new Company({ id: ref.refId, partnerId: partnerId }).goTo(this.$router).detail();
        break;
    }
  }

  get hasOpenDetailListener() {
    return Boolean(this.$listeners && this.$listeners.openDetail);
  }

  get hasClickListener() {
    return Boolean(this.$listeners && this.$listeners.click);
  }
}
